'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetUser } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { InfoModal } from '@/components/ui/info-modal';
import { STREAK_TIERS } from '@/lib/streaks';
import { cn } from '@/lib/ui/utils';
import { TierEmblem } from './tier-emblem';
interface StreakLevelsSheetProps {
  userId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** The 7-tier ladder, with the viewer's current tier highlighted. */
export function StreakLevelsSheet(t0) {
  const $ = _c(26);
  const {
    userId,
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("streaks");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    t2 = ["streakLevel"];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== userId) {
    t3 = {
      identifier: userId,
      walletPubkeys: t1,
      fields: t2
    };
    $[2] = userId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== open) {
    t4 = {
      enabled: open
    };
    $[4] = open;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data
  } = useGetUser(t3, t4);
  const level = data?.streakLevel ?? 0;
  let t5;
  if ($[6] !== t) {
    t5 = t("levels_title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("done");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onOpenChange) {
    t7 = () => onOpenChange(false);
    $[10] = onOpenChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <InfoModal.Footer cta={t6} onClose={t7} />;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== level || $[16] !== t) {
    t9 = STREAK_TIERS.map(tier => {
      const isCurrent = tier.level === level;
      return <div key={tier.level} className={cn("flex items-center gap-3 rounded-control border p-3", isCurrent ? "border-border-brand bg-background-brand" : "border-border-primary")}><span className="grid size-10 shrink-0 place-items-center rounded-panel-inset bg-background-secondary"><TierEmblem level={tier.level} size={26} /></span><div className="min-w-0 flex-1"><div className="text-body font-semibold">{tier.name}</div><div className="text-caption text-foreground-secondary">{tier.milestone}</div></div><span className={cn("shrink-0 font-mono text-caption", isCurrent ? "text-foreground-brand" : "text-foreground-tertiary")}>{t("days_count", {
            count: tier.minDays
          })}</span></div>;
    });
    $[15] = level;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div className="flex flex-col gap-2">{t9}</div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onOpenChange || $[21] !== open || $[22] !== t10 || $[23] !== t5 || $[24] !== t8) {
    t11 = <InfoModal open={open} onOpenChange={onOpenChange} size="default" title={t5} footer={t8}>{t10}</InfoModal>;
    $[20] = onOpenChange;
    $[21] = open;
    $[22] = t10;
    $[23] = t5;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}